import type { PropertySetupField } from './types';

export const PROPERTY_SETUP_FIELDS: Array<PropertySetupField> = [];
